import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56bb020c")

_pushScopeId("data-v-56bb020c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Leads")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "no_leads_container"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "no_leads" }, "Nessun lead da visualizzare", -1)
const _hoisted_6 = {
  key: 1,
  style: {"padding-top":"16px"}
}
const _hoisted_7 = { class: "mode_switcher" }
const _hoisted_8 = {
  key: 0,
  class: "list_container"
}
const _hoisted_9 = { class: "column_title" }
const _hoisted_10 = {
  key: 0,
  class: "section_no_leads_container"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "section_no_leads" }, "Nessun lead da visualizzare", -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "customer" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = {
  key: 0,
  class: "date"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Richiamare il: ")
const _hoisted_18 = {
  key: 1,
  class: "valore"
}
const _hoisted_19 = {
  key: 1,
  class: "kanban_container"
}
const _hoisted_20 = { class: "column_title" }
const _hoisted_21 = { class: "customer" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { class: "info" }
const _hoisted_24 = { class: "date" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Richiamare il: ")
const _hoisted_26 = { class: "valore" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_draggable = _resolveComponent("draggable")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadLeads()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                (!$setup.kanban.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.modeSwitcher, (mode, index) => {
                          return (_openBlock(), _createBlock("div", {
                            key: index,
                            class: ["type", [$setup.selectedMode == String(mode.mode_id) ? 'active' : '']],
                            onClick: ($event: any) => ($setup.setAactiveMode(`${mode.mode_id}`))
                          }, _toDisplayString(mode.mode_label), 11, ["onClick"]))
                        }), 128))
                      ]),
                      ($setup.showLista)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.kanban, (column) => {
                              return (_openBlock(), _createBlock("div", {
                                key: column.title,
                                class: "section"
                              }, [
                                _createVNode("div", {
                                  class: "column_header",
                                  style: {
                                    backgroundColor: `${column.color}`,
                                }
                                }, [
                                  _createVNode("p", _hoisted_9, _toDisplayString(column.title), 1),
                                  _createVNode("span", {
                                    onClick: ($event: any) => ($setup.openNuovoLead(column.columnId)),
                                    class: "new_lead"
                                  }, [
                                    _createVNode(_component_ion_icon, { icon: $setup.addCircle }, null, 8, ["icon"])
                                  ], 8, ["onClick"])
                                ], 4),
                                (column.leads.length === 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                      _hoisted_11
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_12, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.leads, (element, index) => {
                                        return (_openBlock(), _createBlock("div", {
                                          key: index,
                                          class: "lead",
                                          onClick: ($event: any) => ($setup.openDetail(element))
                                        }, [
                                          _createVNode("div", _hoisted_13, _toDisplayString($setup.setShortCustomer(element.nominative)), 1),
                                          _createVNode("div", _hoisted_14, _toDisplayString(element.title), 1),
                                          _createVNode("div", _hoisted_15, [
                                            (element.recall_date)
                                              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                                  _hoisted_17,
                                                  _createVNode("span", {
                                                    class: ["recall_date", $setup.isExpired(element)]
                                                  }, _toDisplayString($setup.dateFormat(element.recall_date)), 3)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (element.value && element.value > 0)
                                              ? (_openBlock(), _createBlock("div", _hoisted_18, "€ " + _toDisplayString(element.value), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ], 8, ["onClick"]))
                                      }), 128))
                                    ]))
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.showKanban)
                        ? (_openBlock(), _createBlock("div", _hoisted_19, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.kanban, (column) => {
                              return (_openBlock(), _createBlock("div", {
                                key: column.title,
                                class: "column"
                              }, [
                                _createVNode("div", {
                                  class: "column_header",
                                  style: {
                                    backgroundColor: `${column.color}`,
                                }
                                }, [
                                  _createVNode("p", _hoisted_20, _toDisplayString(column.title), 1),
                                  _createVNode("span", {
                                    onClick: ($event: any) => ($setup.openNuovoLead(column.columnId)),
                                    class: "new_lead"
                                  }, [
                                    _createVNode(_component_ion_icon, { icon: $setup.addCircle }, null, 8, ["icon"])
                                  ], 8, ["onClick"])
                                ], 4),
                                _createVNode(_component_draggable, {
                                  list: column.leads,
                                  group: "leads",
                                  onStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag = true)),
                                  onEnd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drag = false)),
                                  onChange: ($event: any) => ($setup.changeColumn($event, column, column.leads)),
                                  delayOnTouchOnly: "",
                                  delay: "400",
                                  "item-key": "id",
                                  class: "kanban_column"
                                }, {
                                  item: _withId(({element}) => [
                                    _createVNode("div", {
                                      class: "lead",
                                      onClick: ($event: any) => ($setup.openDetail(element))
                                    }, [
                                      _createVNode("div", _hoisted_21, _toDisplayString($setup.setShortCustomer(element.nominative)), 1),
                                      _createVNode("div", _hoisted_22, _toDisplayString(element.title), 1),
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode("div", _hoisted_24, [
                                          _hoisted_25,
                                          _createVNode("span", {
                                            class: ["recall_date", $setup.isExpired(element)]
                                          }, _toDisplayString($setup.dateFormat(element.recall_date)), 3)
                                        ]),
                                        _createVNode("div", _hoisted_26, "€ " + _toDisplayString(element.value), 1)
                                      ])
                                    ], 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["list", "onChange"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})